"use strict";
/**
 * 作品数据扁平化结构化工具
 */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.structure = exports.flatten = void 0;
var clone_1 = __importDefault(require("./clone"));
var constants_1 = require("./constants");
/**
 * 扁平化作品数据
 * @param appData
 */
function flatten(appData) {
    var app = (0, clone_1.default)(__assign(__assign({}, appData), { pageIds: [] }), true);
    var pagesById = {};
    var cmpsById = {};
    /**
     * 扁平化处理容器组件
     * @param cmp
     */
    function flattenContainerCmps(cmp) {
        if (cmp.containerType === 'tabs') {
            cmp.data.tabs = cmp.data.tabs.map(function (tab) {
                var _a;
                var cmpIds = [];
                (_a = tab.cmps) === null || _a === void 0 ? void 0 : _a.forEach(function (cmp) {
                    cmpIds.push(cmp.id);
                    cmpsById[cmp.id] = cmp;
                    flattenContainerCmps(cmp);
                });
                delete tab.cmps;
                return __assign(__assign({}, tab), { cmpIds: cmpIds });
            });
        }
        if (cmp.containerType === 'container') {
            cmpsById[cmp.data.childCmpId] = cmp.data.childCmp;
            delete cmp.data.childCmp;
        }
    }
    if (appData.appType === constants_1.AppType.normal) {
        // debugger
        appData.pages.forEach(function (page) {
            app.pageIds.push(page.id);
            pagesById[page.id] = (0, clone_1.default)(__assign(__assign({}, page), { cmpIds: [] }), true);
            delete pagesById[page.id].cmps;
            page.cmps.forEach(function (cmp) {
                pagesById[page.id].cmpIds.push(cmp.id);
                cmpsById[cmp.id] = (0, clone_1.default)(cmp, true);
            });
        });
        Object.keys(cmpsById).forEach(function (cmpId) {
            flattenContainerCmps(cmpsById[cmpId]);
        });
    }
    else {
        appData.pages.forEach(function (page) {
            app.pageIds.push(page.id);
            pagesById[page.id] = (0, clone_1.default)(__assign({}, page), true);
        });
    }
    delete app.pages;
    return { app: app, pagesById: pagesById, cmpsById: cmpsById };
}
exports.flatten = flatten;
/**
 * 结构化作品数据
 * @param app
 * @param pages
 * @param cmps
 */
function structure(app, pagesById, cmpsById) {
    if (cmpsById === void 0) { cmpsById = {}; }
    var appData = (0, clone_1.default)(app, true);
    pagesById = (0, clone_1.default)(pagesById, true);
    cmpsById = (0, clone_1.default)(cmpsById, true);
    /**
     * 结构化容器组件
     * @param cmp
     */
    function structureContainerCmps(cmp) {
        if (cmp.containerType === 'tabs') {
            cmp.data.tabs = cmp.data.tabs.map(function (tab) {
                var _a;
                var cmps = [];
                (_a = tab.cmpIds) === null || _a === void 0 ? void 0 : _a.forEach(function (cmpId) {
                    cmps.push(cmpsById[cmpId]);
                    structureContainerCmps(cmpsById[cmpId]);
                });
                delete tab.cmpIds;
                return __assign(__assign({}, tab), { cmps: cmps });
            });
        }
        if (cmp.containerType === 'container') {
            cmp.data.childCmp = cmpsById[cmp.data.childCmpId];
        }
    }
    if (app.appType === constants_1.AppType.normal) {
        var newPages = app.pageIds.map(function (pageId) {
            var page = pagesById[pageId];
            var newCmps = page.cmpIds.map(function (cmpId) {
                structureContainerCmps(cmpsById[cmpId]);
                return cmpsById[cmpId];
            });
            var newPage = __assign(__assign({}, page), { cmps: newCmps });
            delete newPage.cmpIds;
            return newPage;
        });
        appData.pages = newPages;
    }
    else {
        var newPages = app.pageIds.map(function (pageId) {
            var page = pagesById[pageId];
            return __assign({}, page);
        });
        appData.pages = newPages;
    }
    delete appData.pageIds;
    return appData;
}
exports.structure = structure;
exports.default = {
    flatten: flatten,
    structure: structure,
};
